<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Daisies Are Forever</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct"><a id="pagevii"></a><a href="#/contents#cntvii" id="ctnvii">GLOSSARY OF FOREIGN WORDS</a></p>
<p class="txline"></p>
<p class="tx1b">G<span class="small">ERMAN</span> </p>
<p class="tx1a"><span class="small">ACHTUNG</span>—caution </p>
<p class="tx1a"><span class="small">BAHNHOF</span>—railway station </p>
<p class="tx1a"><span class="small">BITTE</span>—please </p>
<p class="tx1a"><span class="small">DANKE</span>—thank you </p>
<p class="tx1a">D<span class="small">ER</span> F<span class="small">ÜHRER</span>—the leader </p>
<p class="tx1a">D<span class="small">EUTSCSCHES</span> R<span class="small">OTES</span> K<span class="small">REUZ</span> (DRK)—German Red Cross </p>
<p class="tx1a"><span class="small">ESSEN KOMMEN</span>—come eat </p>
<p class="tx1a"><span class="small">FLUCHT</span>—escape </p>
<p class="tx1a">F<span class="small">RAU</span>—Mrs.</p>
<p class="tx1a"><span class="small">FRÄULEIN</span>—miss </p>
<p class="tx1a"><span class="small">GUTEN MORGEN</span>—good morning </p>
<p class="tx1a"><span class="small">HALTEN SIE</span>—stop </p>
<p class="tx1a"><span class="small">HERR</span>—mister </p>
<p class="tx1a"><span class="small">JA</span>—yes </p>
<p class="tx1a"><span class="small">KINDER</span>—children </p>
<p class="tx1a"><span class="small">KOMMEN</span>—come </p>
<p class="tx1a">K<span class="small">RISTALLNACHT</span>—series of attacks against the Jews throughout Nazi Germany </p>
<p class="tx1a"><span class="small">LUFTSCHUTZBUNKER</span>—air-raid shelter </p>
<p class="tx1a"><span class="small">MUTTI</span>—mother </p>
<p class="tx1a"><span class="small">NEIN</span>—no </p>
<p class="tx1a"><span class="small">OMA</span>—grandma </p>
<p class="tx1a"><a id="pageviii"><span class="small">ONKEL</span>—uncle </a></p><a id="pageviii">
<p class="tx1a"><span class="small">OPA</span>—grandpa </p>
<p class="tx1a"><span class="small">REICHSMARK</span>(<span class="small">S</span>)—German currency </p>
<p class="tx1a"><span class="small">SCHNELL</span>—quickly </p>
<p class="tx1a">S<span class="small">TALINORGEL</span>—a rocket launcher nicknamed Stalin’s organ </p>
<p class="tx1a"><span class="small">STRASSE</span>—road </p>
<p class="tx1a"><span class="small">TANTE</span>—aunt </p>
<p class="tx1a"><span class="small">TIEFFLIEGER</span>—low-flying German aircraft </p>
<p class="tx1a"><span class="small">VATER</span>—father </p>
<p class="tx1a">V<span class="small">OLKSEMPFÄNGER</span>—people’s radio </p>
<p class="tx1a">V<span class="small">OLKSSTURM</span>—German national militia </p>
<p class="tx1a">Z<span class="small">UM</span> Ö<span class="small">FFENTLICHEN</span> L<span class="small">UFTSCHUTZRAUM</span>—To Public Shelter </p>
<p class="tx1b">R<span class="small">USSIAN </span></p>
<p class="tx1a">Ти<span class="small">Φ</span> к<span class="small"><span class="small">APA</span></span>нтин—Typhus Quarantine </p>
<p class="tx1a"><span class="small">NYET</span>—no </p>
<p class="tx1a"><span class="small">URI</span>—watches </p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?77efb208